export const themeLight = {
  mainBackgroundColor: '#F2F5FC',
  accentColor: '#FF751D',
  tableHeadBackgroundColor: '#F5F6FB',
  tableHeadTextColor: '#000000',
  mainTextColor: '#52555F',
  expensesTextColor: '#E7192E',
  incomesTextColor: '#407946',
  headerColor: '#FFFFFF',
  whiteTextColor: '#FFFFFF',
  chartLight: '#FFDAC0',
  iconColor: '#071F41',
  modalBackgroundColor:
    'linear-gradient(117.84deg, #1D346A 2.84%, #031634 67.28%)',
  lightGreyColor: 'rgba(82, 85, 95, 0.7)',
  userNameColor: ' rgba(82, 85, 95, 1)',
  googleBtnColor: '#f6f7fb',
  tableBodyColor: '#f2f8f8',
  operationTypeSwitchBg: '#FEFEFE',
  operationTypeSwitchBg2: '#FAFBFD',
  borderColor: '#f6f7fc',
  borderColorMin: '#FFFFFF',
  cabbageSvgColor: '#DBDBDB',
  btnWhiteText: '#52555F',
  headerBoxShadow:
    '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
  buttonShadow: 'rgba(82, 85, 95, 0.15)',
  btnGreyColor: '#52555F',
  sectionShadow: 'rgba(170, 178, 197, 0.2)',
  userName: 'rgba(82, 85, 95, 1)',
};

export const themeDark = {
  mainBackgroundColor: '#202225',
  accentColor: '#FF751D',
  tableHeadBackgroundColor: '	#40444b',
  tableHeadTextColor: '#FFFFFF',
  mainTextColor: '#FFFFFF',
  expensesTextColor: '#E7192E',
  incomesTextColor: '#407946',
  headerColor: '#2f3136',
  whiteTextColor: '#FFFFFF',
  chartLight: '#FFDAC0',
  iconColor: '#f2f8f8',
  modalBackgroundColor:
    'linear-gradient(117.84deg, #1D346A 2.84%, #031634 67.28%)',
  lightGreyColor: '#FFFFFF',
  googleBtnColor: '#202225',
  tableBodyColor: '#40444b',
  operationTypeSwitchBg: '#2f3136',
  operationTypeSwitchBg2: '#202225',
  borderColor: '#f6f7fc',
  borderColorMin: '#f6f7fc',
  cabbageSvgColor: '#407946',
  btnWhiteText: '#202225',
  headerBoxShadow: '5px 10px 20px rgb(170 178 197 / 40%)',
  buttonShadow: 'rgba(170 178 197 / 40%)',
  btnGreyColor: '#f6f7fc',
  sectionShadow: 'rgb(255, 255, 255, 0.3)',
  userName: '#FFFFFF',
};
